import Card from './OrganizationCard'
import Modal from './OrganizationModal'

export default {
    Card,
    Modal
}